import { WriteOffCategory } from '@repo/types';

import { useDarkMode } from '@xtnd/web/shared';

import useWriteOffCategory from '../../hooks/useWriteOffCategory';

export const ArWriteOffCategory = ({
  category,
  isStrikeThrough,
}: {
  category: WriteOffCategory;
  isStrikeThrough?: boolean;
}) => {
  const { isDark } = useDarkMode();
  const mode = isDark ? 'dark' : 'light';
  const { getCategoryLabel, getCategoryColor } = useWriteOffCategory(mode);

  const label = getCategoryLabel(category);
  const labelColor = getCategoryColor(category);

  return (
    <span
      className={`text-sm inline-flex items-center px-2 py-1 rounded-full border ${labelColor} truncate ${isStrikeThrough && 'line-through opacity-60'}`}
      title={label}
    >
      {label}
    </span>
  );
};
